<template>
	<div class="justify-center max-w-6xl md:px-6 mx-auto">
		<div class="mb-8">
			<p class="font-bold text-2xl mb-2">{{ title }}</p>
			<div
				v-for="(paragraph, index) in text"
				:key="index"
			>
				<p>{{ paragraph }}</p>
				<br v-if="index != Object.keys(text).length - 1" />
			</div>
		</div>
	</div>
</template>

<script>

export default {
	name: 'ServiceTile',
	props: {
		title: {
			type: String,
			required: true,
		},
		text: {
			type: Array,
			required: true,
		},
	},
}

</script>